<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const tabs = [
  {
    name: 'Accueil',
    icon: 'home.svg',
    id: 'home'
  },
  {
    name: 'Services',
    icon: 'services.svg',
    id: 'services'
  },
  {
    name: 'Historique',
    icon: 'history.svg',
    id: 'history'
  },
  // {
  //   name: 'Coupons',
  //   icon: 'Ticket_use_fill.svg',
  //   id: 'coupons'
  // },
  {
    name: 'Profile',
    icon: 'user.svg',
    id: 'profile'
  }
];

const isActive = (tabId) => {
  return route.name === tabId;
};
</script>

<template>
  <div
    class="hidden md:flex fixed left-0 top-0 h-full w-64 bg-[#070C4C] flex-col z-50 shadow-2xl"
  >
    <!-- logo section -->
    <div class="p-6 border-b border-white/10">
      <div class="flex items-center gap-3">
        <ImgComponent src="/images/logo.svg" class="w-10 h-10" />
        <div class="text-white font-bold text-xl">1BPay</div>
      </div>
    </div>

    <!-- navigation items -->
    <nav class="flex-1 py-6 px-4">
      <div class="space-y-2">
        <router-link
          v-for="tab in tabs"
          :key="tab.id"
          :to="tab.id"
          class="flex items-center gap-4 px-4 py-4 rounded-xl transition-all duration-300"
          :class="{
            'bg-[#FA7607] text-[#070C4C]': isActive(tab.id),
            'text-white/70 hover:bg-white/5 hover:text-white': !isActive(tab.id)
          }"
        >
          <div class="w-6 h-6 flex-shrink-0">
            <ColorImg
              :src="`/images/navs/${tab.icon}`"
              class="w-full h-full"
              :class="{
                'bg-[#070C4C]': isActive(tab.id),
                'bg-current': !isActive(tab.id)
              }"
            />
          </div>
          <span class="font-semibold">{{ tab.name }}</span>
        </router-link>
      </div>
    </nav>

    <!-- user section -->
    <div class="p-4 border-t border-white/10">
      <div class="flex items-center gap-3 px-4 py-3">
        <div class="w-10 h-10 flex-shrink-0">
          <ImgComponent
            :src="$stores.user?.state?.current?.email"
            avatar
            alt="Profile"
            class="w-full h-full rounded-full bg-[#FA7607]"
          />
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-white font-medium truncate">
            {{ $stores.user?.state?.current?.firstName }}
            {{ $stores.user?.state?.current?.lastName }}
          </div>
          <div class="text-white/50 text-sm truncate">
            {{ $stores.user?.state?.current?.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
